import { BaseApiService } from './baseApi';
import type { HobbyItem, ApiResponse } from '../../../../types';

export class HobbiesApiService extends BaseApiService {
  constructor() {
    super('/hobbies');
  }

  async getAll(): Promise<ApiResponse<HobbyItem[]>> {
    return this.requestGet<HobbyItem[]>('', false);
  }

  async getById(id: string): Promise<ApiResponse<HobbyItem>> {
    return this.requestGet<HobbyItem>(`/${id}`, false);
  }

  async create(data: Omit<HobbyItem, 'id' | 'created_at' | 'updated_at'>): Promise<ApiResponse<HobbyItem>> {
    return this.requestPost<HobbyItem>('', data);
  }

  async update(id: string, data: Partial<HobbyItem>): Promise<ApiResponse<HobbyItem>> {
    return this.requestPut<HobbyItem>(`/${id}`, data);
  }

  async deleteHobby(id: string): Promise<ApiResponse<boolean>> {
    return this.requestDelete<boolean>(`/${id}`);
  }

  async remove(id: string): Promise<ApiResponse<boolean>> {
    return this.requestDelete<boolean>(`/${id}`);
  }

  async deleteById(id: string): Promise<ApiResponse<boolean>> {
    return this.requestDelete<boolean>(`/${id}`);
  }

  // method pour réorganiser les hobbies
  async reorder(orders: { id: string; order_index: number }[]): Promise<ApiResponse<boolean>> {
    return this.requestPost<boolean>('/reorder', { hobbyOrders: orders });
  }
}

export const hobbiesApi = new HobbiesApiService();
